module.exports = "<app-global-loader></app-global-loader>\r\n<router-outlet></router-outlet>\r\n"